export default __webpack_public_path__ + "cocktail-glass.png";